import { render, staticRenderFns } from "./TakipKopyalaForm.vue?vue&type=template&id=0abeabf5"
import script from "./TakipKopyalaForm.vue?vue&type=script&lang=ts"
export * from "./TakipKopyalaForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports